import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { LayerBottom, Button } from 'components'
import UserImg from 'images/tmp_user_image.png'
import styles from './index.module.css'
import Swiper from '../../css/Swiper.module.css'
import Lib from 'library'
import { useRecoilValue } from 'recoil'
import { influencerState } from './states'
import DetailTip from 'views/mydata/common/DetailTip'

const ParticipateStop = () => {

	const App = useApp()
	const moreSliceN = 10;
	const [detailTip, setDetailTip] = useState(false)
	const [subscribeInfl, setSubscribeInfl] = useState()
	const [inflLankData, setInflLankData] = useState(0)
	const [influMoreBtn, setInfluMoreBtn] = useState(moreSliceN)
	const [influLength, setInfluLength] = useState(0)
	const myInfoData = useRecoilValue(influencerState)
	const [realTimeChange, setRealTimeChange] = useState(false)



	const openDetail = () => {
		setDetailTip(true)
	}

	const closeDetail = () => {
		setDetailTip(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	useEffect(() => {
		Lib.post(`/api/infl/lst/sbscr`, {
			cnt: ''
		}, data => {
			setSubscribeInfl(data)
			console.log(data)
		})
	}, [realTimeChange])

	useEffect(() => {
		Lib.post(`/api/infl/lst/rank`, data => {
			setInfluLength(Math.ceil(data.length / moreSliceN))
			setInflLankData(data.slice(0, influMoreBtn))
			console.log(data)
		})
	}, [influMoreBtn, realTimeChange])

	const influMoreButton = () => {
		setInfluMoreBtn(influMoreBtn + moreSliceN)
	}

	const influMorebtnBox = () => {
		if (influLength > 1 && (influMoreBtn / moreSliceN) < influLength) {
			return (
				<div className="padding pb_50" onClick={influMoreButton}>
					<Button className="btn btn--big btn-more">+ 더보기</Button>
				</div>
			)
		} else {
			return ''
		}
	}

	const onSbscCancle = (item) => {
		Lib.post(`/api/infl/unsbscr`, {
			unsbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})
	}

	const onSbsc = (item) => {
		Lib.post(`/api/infl/sbscr`, {
			sbscrMbId: item.mbId
		}, data => {
			setRealTimeChange(!realTimeChange)
		})
	}

	return (
		<div className="page">
			{myInfoData && (
				<div className="shadow">
					<div className="padding">
						<div className="flex-justify_between">
							<div className="flex-align_center">
								<div className="img-box user-profile profile_60">
									<img src={UserImg} alt="" />
								</div>
								<h4 className="ml_10"><strong>{myInfoData.ncknm}</strong>님!<br /><span style={{ fontSize: "1.4rem" }}>관리자에 의해 활동이 정지되었습니다.</span></h4>
							</div>
							<i className="icon icon_mark_circle" onClick={openDetail} />
						</div>
					</div>
				</div>
			)}
			<div className="shadow">
				<div className="padding">
					<h3>구독중인 인플루언서</h3>
					<div className={`${Swiper.ScrollArea} mt_20`}>
						{subscribeInfl && subscribeInfl.length > 0 ?
							<ul className={Swiper.slider}>
								{subscribeInfl.map((item, index) => {
									if (index === 10) {
										return (
											<>
												<li key={index} className={item.newYn ? Swiper.noti : ''}>
													<div className="img-box user-profile profile_60">
														<img src={UserImg} alt="" />
													</div>
													<span className="ellipsis">{item.ncknm}</span>
												</li>
												<li>
													<div className={`${Swiper.more} user-profile profile_60`}>
														+
													</div>
													<span>+ 더보기</span>
												</li>
											</>
										)
									} else if (index > 10) {
										return false
									} else {
										return (
											<li key={index} className={item.newYn ? Swiper.noti : ''}>
												<div className="img-box user-profile profile_60">
													<img src={UserImg} alt="" />
												</div>
												<span className="ellipsis">{item.ncknm}</span>
											</li>
										)
									}
								})}
							</ul>
							: '구독중인 인플루언서가 없습니다. 화면 필요합니다.'}
					</div>
				</div>
			</div>
			{inflLankData && inflLankData.length > 0 ? (
				<>
					<h3 className="padding pb_20">구독수가 많은 인플루언서</h3>
					<ul className={`${styles["influencer-list"]} list-bg`}>
						{inflLankData.map((item, index) => {
							let cssMedal = '';
							if (index === 0) cssMedal = 'icon_medal_gold'
							if (index === 1) cssMedal = 'icon_medal_silver'
							if (index === 2) cssMedal = 'icon_medal_bronze'
							return (
								<li key={index}>
									<div className="flex-align_center">
										<span className={styles.number}>{item.rank}</span>
										<div className="flex-align_center ml_20">
											<div className={styles["user"]}>
												<div className="img-box user-profile profile_50">
													<img src={UserImg} alt="" />
												</div>
												<i className={`icon ${cssMedal}`} />
											</div>
											<div className={`${styles.profile} ml_10`}>
												<p>{item.ncknm}</p>
												<span className="flex-align_center mt_5"><span className="text-blue">{item.sbscrCnt}명</span>이 구독중</span>
											</div>
										</div>
									</div>
									{myInfoData && myInfoData.mbId === item.mbId ? '' : item.sbscrYn === 'Y' ? <span className={`${styles.choose} ${styles.cancel}`} onClick={() => onSbscCancle(item)}>구독취소</span> : <span className={`${styles.choose}`} onClick={() => onSbsc(item)}>+ 구독하기</span>}
								</li>
							)
						})}

					</ul>
					{influMorebtnBox()}
				</>
			) : (
				<>
					{/* 데이터 없을 때 */}
					<div className="center-cont py_80">
						<i className="icon_influencer_smile" />
						<p className="mt_15" style={{ fontSize: "1.6rem" }}>첫번째 인플루언서가<br />되어보세요!</p>
					</div>
				</>
			)}

			<DetailTip title="관리자에 의해 활동정지 되었어요!" show={detailTip} closeLayer={closeDetail}>
				<ul className="list-item" style={{ fontSize: "1.4rem" }}>
					<li>
						<span>정지일</span>
						<span>2022.01.05</span>
					</li>
					<li>
						<span>정지사유</span>
						<span>부적절한 언어를 포함한 코멘트 등록</span>
					</li>
					<li>
						<span>해제일</span>
						<span>2022.02.24 (D-23)</span>
					</li>
				</ul>
			</DetailTip>
		</div>
	)
}

export default ParticipateStop
